import axios from 'axios';

import { API_BASE2 } from '../../../assets/config';


const BASE_URL = API_BASE2
const apiService = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // You can adjust the timeout as needed
});

const EmployeeTxnDetailService = {
  
 
  delete: async (id) => {
    // eslint-disable-next-line no-useless-catch
    try {
      
      console.log("error");
      const response = await apiService.delete(`/Employee/Delete?id=`+id);
      return response.data;
    } catch (error) {
      throw error;
    }  
  },
  view: async (id) => {
    console.log(id);
    // eslint-disable-next-line no-useless-catch  
    try {
       
      const response = await apiService.get(`/Employee/EmployeeWithTxnDetail?emp_id=`+id);
      console.log('view data ', id,  JSON.stringify(response));
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
 
  
  
  
};

export default EmployeeTxnDetailService;
